module.exports = __webpack_public_path__ + "img/active_6.126fe5a7.png";